module.exports = __webpack_public_path__ + "static/media/t2-img2.067d8634.png";